import * as React from 'react'
import { Link } from 'react-router-dom'
import { MoonLoader } from 'react-spinners'
import { IOrgObj } from '../../types'
import ServiceDefaultLogo from '../icons/ui/ServiceDefaultLogo'
import EntityHeader from '../ui/entity/EntityHeader'
import EntityHeaderTitle from '../ui/entity/EntityHeaderTitle'
import OrganizationsHeaderTools from './OrganizationsHeaderTools'
import OrganizationTableModal from './OrganizationTableModal'

interface IOrganizations {
  organizations: IOrgObj[]
  isFetchingOrganizations: boolean
  error: string
  getAllOrganizations: () => void
  changeOrganization: (orgId: string) => void
  match: any
  getCurrentOrfID: () => void
  currentOrganizationId: string
}

class Organizations extends React.Component<IOrganizations> {
  public componentDidMount() {
    this.props.getAllOrganizations()
  }

  public changeOrg = (orgId: string) => () => {
    this.props.changeOrganization(orgId)
  }

  public render() {
    return (
      <div className='col-12'>
        <div className='bb-light-grey4'>
          <EntityHeader>
            <EntityHeaderTitle>Organizations list</EntityHeaderTitle>
            <OrganizationsHeaderTools path={this.props.match.path} />
          </EntityHeader>
        </div>

        <div className='flex bb-light-grey4 py2 mx2 m1'>
          <div className='Row-header col-1 h6 bold font-light-blue-grey'>Logo</div>
          <div className='Row-header col-3 h6 bold font-light-blue-grey'>Name</div>
          <div className='Row-header col-3 h6 bold font-light-blue-grey'>Email</div>
          <div className='Row-header col-3 h6 bold font-light-blue-grey'>Service Area</div>
          <div className='Row-header col-2 h6 bold font-light-blue-grey'>Roles</div>
        </div>
        {this.props.organizations.map((org: IOrgObj) => (
          <div className='mx2' key={org.id}>
            <div className='col-12 flex items-center pt1 '>
              <div className='col-1 '>
                <ServiceDefaultLogo className='icon--48x48' />
              </div>
              <Link to={`${this.props.match.path}/${org.id}`} className='col-3 h5 font-dark-grey'>
                {org.name}
              </Link>
              <div className='col-3 h5 font-dark-grey'>{org.email}</div>
              <div className='col-3 h5 font-dark-grey'>{org.serviceAreaName}</div>
              <div className='col-2 h5 font-dark-grey flex'>
                <div className='ml-auto'>
                  <OrganizationTableModal
                    id={org.id}
                    path={this.props.match.path}
                    handleSwitchOrg={this.changeOrg(org.id)}
                    isSelected={org.id === this.props.currentOrganizationId}
                  />
                </div>
              </div>
            </div>
          </div>
        ))}
        <div className='col-12 flex justify-center'>
          <MoonLoader sizeUnit={'px'} size={27} color={'#405264'} loading={this.props.isFetchingOrganizations} />
          {this.props.error && <div>{this.props.error}</div>}
        </div>
      </div>
    )
  }
}

export default Organizations



// WEBPACK FOOTER //
// ./src/components/organizations/Organizations.tsx